import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IReportFieldsPayload, IReportFieldsResponse } from '../types';
import { REPORT_FIELDS_API_URL, REPORT_FIELDS_QUERY, ROLES_PERMISSIONS } from '../constants';

export default function useReportFieldsQuery(
  payload: Ref<IReportFieldsPayload | undefined>,
  isPermitted: Ref<boolean>,
): IContextQueryResult<IReportFieldsResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [REPORT_FIELDS_QUERY, payload],
    queryFn: ({ signal }) => fetchGet<IReportFieldsResponse>(REPORT_FIELDS_API_URL, {
      signal,
      queryParams: { namespace: 'role', ...payload.value },
      permission: ROLES_PERMISSIONS.REPORT_FIELDS,
    }),
    enabled: computed(() => !!payload.value && isPermitted.value),
    placeholderData: keepPreviousData,
  });
}
